/**
 * Уровень серьёзности ошибки — аналог severity на беке (E_NOTICE / E_WARNING / E_ERROR)
 */
const ErrorSeverity = {
    /** Валидационная — показать пользователю, в Sentry не репортить */
    Notice:  'notice',
    /** Предупреждение — показать пользователю, репортить в Sentry */
    Warning: 'warning',
    /** Критическая — показать пользователю, репортить в Sentry как error */
    Error:   'error',
} as const;

type ErrorSeverityType = typeof ErrorSeverity[keyof typeof ErrorSeverity];

export { ErrorSeverity, ErrorSeverityType };